import authRules from '../authRules';

const addAssignmentViewDescription = (user) => {
  const { assignmentComment } = user.securityLevels;
  if (assignmentComment >= authRules.addAssignmentViewDescription.assignmentComment) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewDescription;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentViewDescription.js